import React from 'react';

const StudentAccordion = ({ studentInfoArray }) => {
  return (
    <div id="accordion">
      {studentInfoArray.map((studentInfo, index) => {
        const accordionId = `collapse${index}`;
        const srNum = index + 1;

        return (
          <div key={index} className="card">
            <div className="card-header" id={`heading-${index}`}>
              <h5 className="mb-0 row d-flex">
                <div className="col-3 mt-2">{srNum}</div>
                <button
                  className="btn acbtn col-6"
                  data-bs-toggle="collapse"
                  data-bs-target={`#${accordionId}`}
                  aria-expanded="true"
                  aria-controls={accordionId}
                >
                  {studentInfo.name}
                </button>
              </h5>
            </div>
            <div id={accordionId} className="collapse" aria-labelledby={`heading-${index}`} data-bs-parent="#accordion">
              <div className="card-body">
                <h5 className="text-light">Student Details</h5>
                <div className="cdiv p-3 rounded">
                  <div className="row">
                    <div className="col-3">
                      <p className="card-text">Student_ID:</p>
                    </div>
                    <div className="col-6">
                      <p className="card-text">{studentInfo.id}</p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-3">
                      <p className="card-text">Email_ID:</p>
                    </div>
                    <div className="col-6">
                      <p className="card-text">{studentInfo.email}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-3">
                      <p className="card-text">Contact #:</p>
                    </div>
                    <div className="col-6">
                      <p className="card-text">{studentInfo.contact}</p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-3">
                      <p className="card-text">Degree:</p>
                    </div>
                    <div className="col-6">
                      <p className="card-text">{studentInfo.degree}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-3">
                      <p className="card-text">Project:</p>
                    </div>
                    <div className="col-8">
                      <p className="card-text">
                        <b>"{studentInfo.project}"</b>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StudentAccordion;
